import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import TeamworkGraphIcon from '@atlaskit/icon-lab/core/teamwork-graph';

import { PreviewPanelTitle } from '@atlassian/preview-panel/preview-panel-title';

const i18n = defineMessages({
	title: {
		id: 'byline-connections.preview-panel.title-context',
		defaultMessage: 'Context',
		description:
			'Title shown in the preview panel header above work and links related to the current page.',
	},
});

// `label=""` because the title text beside it already names the panel.
const titleIcon = <TeamworkGraphIcon label="" testId="teamwork-graph-preview-panel-title-icon" />;

export const TeamworkGraphPreviewPanelTitle = (): React.JSX.Element => {
	const { formatMessage } = useIntl();

	return <PreviewPanelTitle title={formatMessage(i18n.title)} icon={titleIcon} />;
};
